const AnjuSinglesStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1eysiEKpsogwt7kmRmtcrg?si=5cffbadb044c4340" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-XEyew8z9UpoVR99A-Ctn5Dg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Away Message</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4Bdoj6ymgDQ0LZdfR4AZ2E?si=5c832ae44e2342de" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-qxh1GQ7i2XsqhUr7-TIgZJA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>I Uhhhhh</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/rave-tool" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-fKHMwXQWCF534ISz-qf55Rg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Rave Tool</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Music Video / Single</p>
            <a href="https://www.youtube.com/watch?v=Bs84gP1d888" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02264fc0884fd1a7358886ac1a" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Katy</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2UiSXHE6Y3KAIsfCCo67kW?si=8f4ff287c6ce4cbe" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yteAvdxDvR6I55bi-43Pjlw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>4th Floor Hallway</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0p8xn5zhYLz0eYM9Rm4BTy?si=fa6fef479a144467" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-yteAvdxDvR6I55bi-43Pjlw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ANJUcore</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/27uAJ6UU7SCXthoPFK8JEY?si=e73a2cdb960748d6" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yteAvdxDvR6I55bi-43Pjlw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>A Love Letter to My Akai</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0LnoYV9Ktxdok3xOye9Cnx?si=37ed6dcc47164855" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yteAvdxDvR6I55bi-43Pjlw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Handmirror</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/43yUpWMe4OIn5Xm4vVolxP?si=93543bb87b674185" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yteAvdxDvR6I55bi-43Pjlw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Gunmetal</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2LJ0o2dsAj0ObeloTYnUgg?si=5e6d4ab8dd904c94" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yteAvdxDvR6I55bi-43Pjlw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Elixir</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0dIzMzWKIKU1qtmgeUcEZu?si=eaf58530cc5d4d34" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yteAvdxDvR6I55bi-43Pjlw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Solid State Memories</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7deooiS0UWqz3F8Xr7q4VX?si=759fd988e1a14d5c" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yteAvdxDvR6I55bi-43Pjlw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>I Think I'm Ready Now (Interlude)</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3LQlElCLsz4oaHnY4tKKXh?si=5798f4ab394a438d" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yteAvdxDvR6I55bi-43Pjlw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Ok Yeah... For Sure</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6U7lqReUObvSFCr3tv4Yfp?si=06b3dd9e70f44c27" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yteAvdxDvR6I55bi-43Pjlw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Backroom</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2KMG3eEjaUWNfQrDNNz32D?si=0e6b9a7552254724" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-2hiibxk8Rz27EfAI-Vk4ozw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Technology</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1RY9FprhayEsfvFiSSJe6Z?si=ec9fa801c93b4952" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-yteAvdxDvR6I55bi-43Pjlw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Memory Leak</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0JWRHn6RzoSFTFjr6fjVrF?si=5390c8f13a6e499d" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yteAvdxDvR6I55bi-43Pjlw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Knife Practice</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6PGRiwsikB36Xf2WUMhCTa?si=8c040fcce7ff4fd4" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-yteAvdxDvR6I55bi-43Pjlw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Status Effect</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3RKLue8lbXdm7e9siiXdCa?si=f2b9cca8af7042d8" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yteAvdxDvR6I55bi-43Pjlw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Stratus</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/71SWQvh58lo5B4FHLzsbe3?si=a6a9e204cbc743d8" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yteAvdxDvR6I55bi-43Pjlw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>We All Change / It's Fine</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Music Video / Single</p>
            <a href="https://www.youtube.com/watch?v=0PDDyumLrYo" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-wDezjcyyNBP4WjQZ-zFdTCg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>SWAG SUPPLIER</strong><br/>(feat. Kawaii Ry & STARINTHESKY)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1OeOaYFIieCjVVn2Yl2Qxh?si=e01a3bf087db4d9e" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273f8f425ed3f229026f4806269" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Mr. Drill / pist off</strong><br/>(feat. Kawaii Ry)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/hellscapedigital/camo-croc" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-M65REbxvpBKAYv1s-c35jbg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Camo Croc</strong><br/>
                (feat. Kawaii Ry)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/passing-brussels" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-wwoT34wzHbb7vSWv-fe9Xfg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Passing Brussels</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/observatory" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-wwoT34wzHbb7vSWv-fe9Xfg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Observatory</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/jailbroken-ipod-touch" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-wwoT34wzHbb7vSWv-fe9Xfg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Jailbroken iPod Touch</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/second-date" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-wwoT34wzHbb7vSWv-fe9Xfg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Second Date</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/idc-ill-rave-by-myself" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-b4ry8oGyxBgFuaXf-5hfiMw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Idc I'll Rave by Myself</strong>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/i-can-make-a-call-1" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-tW8h6chnIw4bfGKY-OnJnKw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>I Can Make A Call</strong>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/rainbow-bodega" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-U4RGgfX5Ay7tVLOM-3ygPMg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Rainbow Bodega</strong><br/>
              (feat. Meauxminy)
              </p>
            </a>
          </div>           

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/mall-date" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-zm4J63XdnzhtdZKK-GPA3Vw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Mall Date</strong>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/4am-anxiety-bath" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Q19eAGloMKaNew6y-frYxow-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>4AM Anxiety Bath</strong>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/recaptcha-invalid" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-QSD3TSSOjs6fKds6-0K3YMQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>reCAPTCHA / Invalid</strong>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/knife-shopping" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000612828961-z6bi6e-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Knife Shopping</strong>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/ringtone4myburnermp3" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000652553566-qym0d6-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Ringt0ne4MyBurner.mp3</strong>
              </p>
            </a>
          </div>          

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/flora-1" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000608076520-bpxk7e-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Flora</strong>
              </p>
            </a>
          </div>         

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/distracted-active" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000479130057-gvq3oj-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Distracted / Active!</strong>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/4th-floor-balcony-ft-meezow" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000445591854-2idp45-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>4th Floor Balcony</strong><br/>
                (feat. Meezow)
              </p>
            </a>
          </div>   

        </div>
      </>
    );
  };
  export default AnjuSinglesStatic;